export default __webpack_public_path__ + "static/media/autoTranslate.eee3e5b5.svg";